export const pharmacyQuestions = [
    {
        section: "Pharmacy Knowledge",
        en: {
            question: "What is OTC medicine?",
            options: [
                "A medicine available without prescription",
                "A medicine only doctors can use",
                "A medicine used in hospitals only",
                "A medicine for children only"
            ],
            answer: "A medicine available without prescription"
        },
        hi: {
            question: "OTC दवा क्या है?",
            options: [
                "बिना प्रिस्क्रिप्शन के मिलने वाली दवा",
                "केवल डॉक्टर ही उपयोग कर सकते हैं ऐसी दवा",
                "केवल अस्पतालों में उपयोग की जाने वाली दवा",
                "केवल बच्चों के लिए दवा"
            ],
            answer: "बिना प्रिस्क्रिप्शन के मिलने वाली दवा"
        }
    },
    {
        section: "Pharmacy Knowledge",
        en: {
            question: "Which of the following is an antibiotic?",
            options: ["Paracetamol", "Amoxicillin", "Cetirizine", "Ibuprofen"],
            answer: "Amoxicillin"
        },
        hi: {
            question: "निम्नलिखित में से कौन सी एक एंटीबायोटिक है?",
            options: ["पैरासिटामोल", "एमोक्सिसिलिन", "सेटिरिज़िन", "इबुप्रोफेन"],
            answer: "एमोक्सिसिलिन"
        }
    },
    {
        section: "Customer Handling",
        en: {
            question: "If a customer comes with an unclear prescription, what should you do?",
            options: [
                "Guess the medicine and give it",
                "Ask the customer to tell the medicine name",
                "Politely ask the customer to consult the doctor again for clarity",
                "Refuse to talk to the customer"
            ],
            answer: "Politely ask the customer to consult the doctor again for clarity"
        },
        hi: {
            question: "यदि कोई ग्राहक अस्पष्ट प्रिस्क्रिप्शन के साथ आता है, तो आपको क्या करना चाहिए?",
            options: [
                "दवा का अंदाजा लगाएं और दे दें",
                "ग्राहक से दवा का नाम बताने के लिए कहें",
                "स्पष्टता के लिए ग्राहक से दोबारा डॉक्टर से परामर्श करने के लिए विनम्रतापूर्वक कहें",
                "ग्राहक से बात करने से मना कर दें"
            ],
            answer: "स्पष्टता के लिए ग्राहक से दोबारा डॉक्टर से परामर्श करने के लिए विनम्रतापूर्वक कहें"
        }
    },
    {
        section: "Situational Questions",
        en: {
            question: "You noticed a medicine is nearing its expiry date in 1 month. What is the best action?",
            options: [
                "Keep it on the shelf until it expires",
                "Move it to the front and try to sell it fast",
                "Inform the manager and mark it for return/near-expiry disposal",
                "Throw it in the trash immediately"
            ],
            answer: "Inform the manager and mark it for return/near-expiry disposal"
        },
        hi: {
            question: "आपने देखा कि एक दवा 1 महीने में समाप्त (expiry) होने वाली है। सबसे अच्छा कदम क्या है?",
            options: [
                "इसे समाप्त होने तक शेल्फ पर रखें",
                "इसे सामने रखें और तेजी से बेचने की कोशिश करें",
                "मैनेजर को सूचित करें और इसे वापसी/निकट-समाप्ति निपटान के लिए चिह्नित करें",
                "इसे तुरंत कचरे में फेंक दें"
            ],
            answer: "मैनेजर को सूचित करें और इसे वापसी/निकट-समाप्ति निपटान के लिए चिह्नित करें"
        }
    }
];
